import { ComponentPropsWithoutRef } from "react";
import { cn } from "utils/cn";

export function ChatbotWrapper(props: ComponentPropsWithoutRef<"div">) {
  return (
    <div
      {...props}
      className={cn(
        "relative flex min-h-0 flex-col items-stretch font-sans text-zi-text",
        props.className
      )}
    />
  );
}
